<template>
  <div>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div
        class="flex flex-row justify-between items-center col-span-1 lg:col-span-3 bg-red-600 p-4 rounded-lg text-white"
        v-if="userData.suspended"
      >
        <span
          >This user is currently suspended. The user will not be able to log in
          or receive any correspondances.</span
        >
        <button
          class="px-3 py-1.5 bg-white rounded-lg text-gray-900 font-medium text-sm hover:bg-gray-200 focus:bg-gray-200 focus:outline-none"
          v-on:click="
            $eventBus.$emit('admin-user-suspend-modal-open', userData)
          "
        >
          Restore User
        </button>
      </div>
      <div
        class="col-span-1 bg-white rounded-md flex flex-col p-6 space-y-4 relative shadow-sm lg:col-span-2"
      >
        <div class="flex flex-row justify-between content-center">
          <h1 class="text-base font-medium text-gray-900 flex-1">
            {{ userData.name }}
          </h1>
          <PopperDropdown class="top-0 right-0">
            <template v-slot:dropdown-button>
              <button
                type="button"
                class="text-gray-400 hover:text-gray-900 focus:outline-none"
                id="options-menu"
                aria-haspopup="true"
                aria-expanded="true"
              >
                <i class="fa-solid fa-ellipsis"></i>
              </button>
            </template>
            <template v-slot:dropdown-content>
              <div
                class="px-4 py-2 text-sm bg-gray-100 text-gray-600"
                role="none"
              >
                <p class="font-normal" role="none">
                  Quick Actions
                </p>
              </div>
              <button
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
                role="menuitem"
                v-on:click="
                  $eventBus.$emit('admin-user-update-modal-open', userData)
                "
              >
                Modify User Info
              </button>
              <button
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
                role="menuitem"
                v-on:click="
                  $eventBus.$emit(
                    'admin-user-reset-password-modal-open',
                    userData
                  )
                "
              >
                Reset Password
              </button>
              <button
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
                role="menuitem"
                v-on:click="
                  $eventBus.$emit(
                    'admin-user-change-permissions-modal-open',
                    userData
                  )
                "
              >
                Change Permissions
              </button>
              <button
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
                role="menuitem"
                v-on:click="
                  $eventBus.$emit(
                    'admin-modify-stringer-percent-open-modal',
                    userData
                  )
                "
                v-if="!userData.role.includes('media')"
              >
                Modify User Percentage
              </button>
              <button
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
                role="menuitem"
                v-on:click="
                  $eventBus.$emit('admin-user-suspend-modal-open', userData)
                "
              >
                Suspend User
              </button>
            </template>
          </PopperDropdown>
        </div>
        <dl
          class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2"
          v-if="userData"
        >
          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">
              Phone
            </dt>
            <dd class="mt-1 text-sm text-gray-900">
              {{ userData.settings.phone }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">
              Email
            </dt>
            <dd class="mt-1 text-sm text-gray-900">
              {{ userData.email }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">
              City, State
            </dt>
            <dd class="mt-1 text-sm text-gray-900">
              {{ userData.settings.city }}, {{ userData.settings.state }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">
              Zip
            </dt>
            <dd class="mt-1 text-sm text-gray-900">
              {{ userData.settings.zipcode }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="text-sm font-medium text-gray-500">
              Birthday
            </dt>
            <dd class="mt-1 text-sm text-gray-900">
              June 8, 1990
            </dd>
          </div>
        </dl>
      </div>
      <div class="bg-white rounded-md col-span-1 shadow-sm">
        <div class="p-6">
          <div class="flex flex-row items-center">
            <h2
              class="text-base font-medium text-gray-900 flex-1"
              id="stats-title"
            >
              User Statistics
            </h2>
            <span
              class="text-xs font-light text-gray-500"
              v-tippy
              title="Stats are updated once every six hours."
              v-if="!userData.role.includes('media')"
              >updated {{ userData.stats.lastUpdated | timeAgo }}</span
            >
          </div>
          <div class="flow-root text-sm mt-6">
            <div
              class="-my-5 divide-y divide-gray-200 pb-2"
              v-if="!userData.role.includes('media')"
            >
              <div class="flex flex-row items-center py-3 group">
                <div class="flex-1">
                  Videos to sales ratio
                  <i
                    class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                    v-tippy
                    title="Derived from all of videos and sales over the past year."
                  ></i>
                </div>
                <span>{{ userData.stats.videosToSalesRatio }}</span>
              </div>
              <div class="flex flex-row items-center py-3 group">
                <div class="flex-1">
                  Videos past year
                  <i
                    class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                    v-tippy
                    title="Calculated by counting the videos uploaded last year (365 days) and the year prior. The percentage is found by finding the percent increase from the year prior to the most recent year."
                  ></i>
                </div>
                <span
                  >{{ userData.stats.videosPastYear }}
                  <span
                    class="text-gray-500 text-xs"
                    :class="{
                      'text-red-600':
                        userData.stats.videosPercentageIncrease < 0,
                      'text-green-600':
                        userData.stats.videosPercentageIncrease > 0
                    }"
                    >(<span v-if="userData.stats.videosPercentageIncrease > 0"
                      >+</span
                    >{{
                      Math.round(userData.stats.videosPercentageIncrease)
                    }}%)</span
                  ></span
                >
              </div>
              <div class="flex flex-row items-center py-3 group">
                <div class="flex-1">
                  Sales past year
                  <i
                    class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                    v-tippy
                    title="Calculated by counting the sales in the last year (365 days) and the year prior. The percentage is found by finding the percent increase from the year prior to the most recent year."
                  ></i>
                </div>
                <span
                  >{{ userData.stats.salesPastYear }}
                  <span
                    class="text-gray-500 text-xs"
                    :class="{
                      'text-red-600':
                        userData.stats.salesPercentageIncrease < 0,
                      'text-green-600':
                        userData.stats.salesPercentageIncrease > 0
                    }"
                    >(<span v-if="userData.stats.salesPercentageIncrease > 0"
                      >+</span
                    >{{
                      Math.round(userData.stats.salesPercentageIncrease)
                    }}%)</span
                  ></span
                >
              </div>
              <div class="flex flex-row items-center py-3 group">
                <div class="flex-1">
                  Lifetime videos
                  <i
                    class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                    v-tippy
                    title="A count of all of the videos the user has uploaded."
                  ></i>
                </div>
                <span>{{ userData.stats.videosTotal }} </span>
              </div>
              <div class="flex flex-row items-center py-3 group">
                <div class="flex-1">
                  Lifetime sales
                  <i
                    class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                    v-tippy
                    title="A count of all of the sales ever had via the CDN. This value does not account for sales prior to January 1, 2017 or stock sales."
                  ></i>
                </div>
                <span>{{ userData.stats.salesTotal }} </span>
              </div>
              <div class="flex flex-row items-center py-3 group">
                <div class="flex-1">
                  Average video rating
                  <i
                    class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                    v-tippy
                    title="An average of all video ratings within the past 365 days."
                  ></i>
                </div>
                <span>
                  <StarRating
                    :rating="Math.round(userData.stats.averageVideoRating)"
                  />
                </span>
              </div>
              <!-- <div class="flex flex-row items-center py-3 group">
                    <div class="flex-1">
                      Lifetime Social Earnings
                      <i
                        class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                        v-tippy
                        title="The amount of money that you have made through our social media platforms' ad revenue since September 2022."
                      ></i>
                    </div>
                    <span>
                      {{ userData.stats.socialIncomeLifetime | displayMoney}}
                    </span>
                  </div>
                  <div class="flex flex-row items-center py-3 group">
                    <div class="flex-1">
                      Social Earnings Balance
                      <i
                        class="fad fa-info-circle text-gray-600 opacity-0 group-hover:opacity-100 transition-all"
                        v-tippy
                        title="Payouts will occur once your account reaches a $100 threshold."
                      ></i>
                    </div>
                    <span>
                      {{ userData.stats.socialIncomeBalance | displayMoney}}
                    </span>
                  </div> -->
            </div>
            <span v-if="userData.role.includes('media')">
              Not currently available for media members.
            </span>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-md overflow-hidden col-span-3 shadow-sm">
        <div class="px-6 pt-6">
          <div class="flex flex-row items-center justify-between">
            <h2
              class="text-base font-medium text-gray-900 flex-1"
              id="stats-title"
            >
              Logged In Sessions
            </h2>
            <span
              class="inline-flex items-center px-2.5 py-0.5 text-blue-700 bg-blue-100 p-2 text-sm rounded-full"
              >Coming Soon</span
            >
          </div>
        </div>
        <div class="pt-2">
          <div class="p-6 pt-4">
            View users currently logged in devices. Some of the recent sessions
            are listed below; however, this list may not be exhaustive.
          </div>
        </div>
      </div>
      <div class="bg-white rounded-md overflow-hidden col-span-3 shadow-sm">
        <div class="px-6 pt-6">
          <div class="flex flex-row items-center justify-between">
            <h2
              class="text-base font-medium text-gray-900 flex-1"
              id="stats-title"
            >
              Recent User Events
            </h2>
            <span
              class="inline-flex items-center px-2.5 py-0.5 text-blue-700 bg-blue-100 p-2 text-sm rounded-full"
              >Coming Soon</span
            >
          </div>
        </div>
        <div class="pt-2">
          <div class="p-6 pt-4">
            This user doesn't have any recent account events.
          </div>
        </div>
      </div>
      <div class="bg-white rounded-md overflow-hidden col-span-3 shadow-sm">
        <div class="px-6 pt-6">
          <div class="flex flex-row items-center">
            <h2
              class="text-base font-medium text-gray-900 flex-1"
              id="stats-title"
            >
              Recent Email Errors
            </h2>
          </div>
        </div>
        <div class="pt-2">
          <div class="p-6 pt-4" v-if="userData.mail_errors.length == 0">
            This user doesn't have any recent email bounces.
          </div>
          <table
            class="min-w-full divide-y divide-gray-300 "
            v-if="userData.mail_errors.length !== 0"
          >
            <thead class="border-t border-gray-300">
              <tr>
                <th
                  scope="col"
                  class="pl-6 py-3.5 pr-3 text-left text-sm font-semibold text-gray-900 "
                >
                  Bounce Type
                </th>
                <th
                  scope="col"
                  class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
                >
                  Status
                </th>
                <th
                  scope="col"
                  class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
                >
                  Date
                </th>
                <th
                  scope="col"
                  class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
                >
                  Context
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr
                class="hover:bg-gray-200 cursor-pointer"
                v-for="error in userData.mail_errors"
                v-bind:key="error.id"
                v-on:click="
                  () => {
                    selectedError = error;
                    $eventBus.$emit('admin-error-email-details-modal-open');
                  }
                "
              >
                <td
                  class="whitespace-nowrap py-4 pl-6 pr-3 text-sm font-medium text-gray-900 "
                >
                  {{ error.bounce_type }}
                </td>
                <td class="whitespace-nowrap py-4 px-3 text-sm text-gray-500">
                  {{ error.status }}
                </td>
                <td class="whitespace-nowrap py-4 px-3 text-sm text-gray-500">
                  {{ error.aws_timestamp | displayLocalDateTime }}
                </td>
                <td class="whitespace-nowrap py-4 px-3 text-sm text-gray-500">
                  <span
                    class="px-3 py-1  rounded-full text-sm"
                    :class="{
                      'bg-gray-200':
                        error.mailDescription.status_code == 'unknown',
                      'bg-gray-800 text-white':
                        error.mailDescription.status_code == 'blacklist',
                      'bg-yellow-200':
                        error.mailDescription.status_code == 'address_unknown',
                      'bg-red-200':
                        error.mailDescription.status_code == 'address_deleted',
                      'bg-blue-200':
                        error.mailDescription.status_code == 'hop_error'
                    }"
                    >{{ error.mailDescription.message }}</span
                  >
                </td>
              </tr>

              <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <EmailErrorDetailsModal :selectedError="selectedError" />
    <UserModifyPercentModal />
    <UserModifySettingsModal />
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapGetters } from "vuex";

import CustomTable from "@/components/general/CustomTable";
import PopperDropdown from "@/components/partials/PopperDropdown";
import StarRating from "@/components/general/StarRating";
import EmailErrorDetailsModal from "@/screens/admin/modals/EmailErrorDetailsModal";
import UserModifyPercentModal from "@/screens/admin/modals/UserModifyPercentModal";
import UserModifySettingsModal from "@/screens/admin/modals/UserModifySettingsModal";

export default {
  name: "AdminUsers",
  props: ["userData"],
  data() {
    return {
      selectedError: null
    };
  },
  components: {
    CustomTable,
    PopperDropdown,
    StarRating,
    EmailErrorDetailsModal,
    UserModifyPercentModal,
    UserModifySettingsModal
  },
  filters: {
    displayMoney: function(value) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            });
            return formatter.format(value);
        },
  }
};
</script>
